import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';

import ActionsFormatter from './ActionsFormatter';

const ProductColumns = () => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();

    const nameColumn = [
        {
            field: 'name',
            flex: 1,
            headerName: t('Name'),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box display="flex" flexDirection="column">
                        <Typography variant="body2">
                            {row.first_name} {row.last_name}
                        </Typography>
                        <Typography variant="caption">{row.email}</Typography>
                    </Box>
                );
            },
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) {
        return nameColumn;
    }

    return [
        ...nameColumn,
        {
            field: 'role_name',
            flex: 1,
            headerName: t('Role'),
        },
        {
            field: 'phone',
            flex: 1,
            headerName: t('Telephone'),
        },
        {
            field: '',
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return <ActionsFormatter row={row} />;
            },
            sortable: false,
        },
    ];
};

ProductColumns.propTypes = {};

export default ProductColumns;
